import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchRequest,
  fetchSuccess,
  fetchFailure,
  downloadSuccess,
  downloadFailure,
  locationTypes,
  createSuccess,
  createFailure,
  uploadImageRequest,
  uploadImageResponse,
  deleteImageResponse,
  fetchImageResponse,
  setLocationData,
  fetchSuccessAll,
} from "../actions/location";
import { getRandomId } from "../../global/utility/Utils";
import { updateUI } from "../actions/deviceProfile";
import {
  fetchLocationEndPoint,
  createLocationEndPoint,
  fetchImageEndPoint,
  uploadImageEndPoint,
  deleteImageEndPoint
} from "../../configuration";
import { getRandomUUID } from "../../Token";

import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";
import { create } from "@mui/material/styles/createTransitions";

function* fetchLocationSaga(action) {
  try {
    const limit = action.payload?.limit;
    const payload = yield select((state) => ({
      name: state.location.filter.name,
      address: state.location.filter.address,
      createtype: state.location.filter.createtype,
      pageNo: state.location.filter.pageNo,
      limit: limit ? limit : state.location.filter.limit,
    }));

    const locationResponse = yield call(fetchLocationAPI, payload);

    const locations = locationResponse?.locations?.filter(
      (loc) =>
        (loc.kind === "ts.tag.site" && loc?.name && loc?.address) ||
        (loc.tags &&
          loc.tags.length > 0 &&
          loc.tags[0].kind === "ts.tag.site" &&
          loc?.tags[0]?.name &&
          loc?.tags[0]?.address)
    );

    yield put(
      fetchSuccess({
        total: locationResponse?.totalCount || 0,
        locations: locations,
      })
    );
  } catch (error) {
    console.log("error", error);
    yield put(fetchFailure(error.message));
  }
}

async function fetchLocationAPIAll() {
let fields = { ['$sort']: [{ field: "createdon", order: "desc" }] };
const response = await fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { ...fields }
    }),
  });
  return response.json();
}

function* fetchLocationSagaAll() {
  try {
    const locationResponse = yield call(fetchLocationAPIAll, {});

    const locations = locationResponse?.locations?.filter(
      (loc) =>
        (loc.kind === "ts.tag.site" && loc?.name && loc?.address) ||
        (loc.tags &&
          loc.tags.length > 0 &&
          loc.tags[0].kind === "ts.tag.site" &&
          loc?.tags[0]?.name &&
          loc?.tags[0]?.address)
    );
    yield put(
      fetchSuccessAll({
        locations: locations,
      })
    );
  } catch (error) {
    yield put(fetchFailure(error.message));
  }
}

async function fetchLocationAPI(payload) {
  let $sort = [{ field: "createdon", order: "desc" }];
  let fields = {};
  if (Object.hasOwn(payload, "name") && payload.name) {
    if (payload?.name?.value) {
      fields = { ...fields, name: payload?.name?.value };
    }
    if (payload?.name?.sort) {
      $sort = [{ field: "name", order: payload?.name?.sort }];
    } else {
      $sort = [{ field: "createdon", order: "desc" }];
    }
  }
  if (Object.hasOwn(payload, "address") && payload.address) {
    if (payload?.address?.value) {
      fields = { ...fields, address: payload?.address?.value };
    }
  }

  if (Object.hasOwn(payload, "createtype") && payload.createtype) {
    if (payload?.createtype?.value) {
      fields = { ...fields, createtype: payload?.createtype?.value === "Inventory" ? "inventory_location" : "shipment_location" };
    }
  }

  let filter = {$sort};
  if (Object.keys(fields).length > 0) {
    filter = { ...filter, fields };
  }

  if(payload?.limit !== -1){
    filter = { ...filter, $pagenumber: payload?.pageNo || 0, $limitnumber: payload?.limit || 50 };
  }

  const response = await fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter,
    }),
  });
  return response.json();
}

const uploadImageAPI = async (query) => {
  try {
    const response = await fetch(uploadImageEndPoint(), {
      method: "POST",
      headers: {
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "Content-Type": "application/octet-stream",
      },
      body: query, // query is FormData containing the binary image file
    });

    if (!response.ok) new Error("API error");
    return response.json();
  } catch (error) {
    console.log(error);
  }
};

const deleteImageAPI = async (id) => {
  try {
    const response = await fetch(deleteImageEndPoint(), {
      method: "DELETE",
      headers: {
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      },
      body: JSON.stringify({
        accountname: sessionStorage.getItem("accountId"),
        resourceidentifier: {
          id,
        }
      }), // query is FormData containing the binary image file
    });

    if (!response.ok) new Error("API error");
    return response;
  } catch (error) {
    console.log(error);
  }
};

function* uploadImageSaga(action) {
  try {
    const {file:imageFile, floorImageId, floorKey} = action.payload;
    const response = yield call(uploadImageAPI, imageFile);
    if(floorKey !== undefined && floorImageId !== undefined){
        const location_data = yield select((state) => state.location.location_data);
        const updatedFloors = { ...location_data.floors };
        updatedFloors[floorKey] = { ...updatedFloors[floorKey], file: imageFile, floorImageId: response?.id };
        yield put(setLocationData({ ...location_data, imageIdsForDelete: [...location_data.imageIdsForDelete, floorImageId], floors: { ...updatedFloors } }));
        // deleteImageAPI(floorImageId);
    }else{
      const location_data = yield select((state) => state.location.location_data);
      const id = getRandomId('floor');
      yield put(setLocationData({ ...location_data,editNewFloorUpdatedId:id, floors: { ...location_data.floors, [id]: { id,file_name: imageFile?.name, file: imageFile, floorImageId: response?.id } } }));
    }
    yield put(uploadImageResponse({data : response?.id, success: true}));
  } catch (error) {
    console.log("error", error);
    yield put(uploadImageResponse({data : error.message, success: false}));
  }
}

const fetchImageAPI = async (id) => {

  try {
    const response = await fetch(fetchImageEndPoint(), {
      method: "POST",
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
         "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accountname: sessionStorage.getItem("accountId"),
        resourceidentifier: {
          id,
        }
      })
    });

    if (!response.ok) {
      return response.json();
    } else {
      const blob = await response.blob();
      return blob;
    }
  } catch (error) {
    console.log(error);
  }
};

function* fetchImageSaga(action) {
  
  try {
    const imageIds = action.payload;
    for (const id of imageIds) {
      const { imageId, floorKey } = id;
      const response = yield call(fetchImageAPI, imageId);
      if (response instanceof Blob) {
        const location_data = yield select((state) => state.location.location_data);
        yield put(setLocationData({ ...location_data, floors: { ...location_data.floors, [floorKey]: { ...location_data.floors[floorKey], file: response } } }));
        yield put(fetchImageResponse({ [floorKey]: { data: response, success: true } }));
      } else {
        yield put(fetchImageResponse({ [floorKey]: { data: response?.message || 'Error fetching image', success: false } }));
      }
      yield put(fetchImageResponse({ready:true})); // Reset upload image state
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* deleteImageSaga(action) {
  try {
    const { imageId } = action.payload;
    const response = yield call(deleteImageAPI, imageId);
    yield put(deleteImageResponse({data : response?.id, success: true}));
  } catch (error) {
    console.log("error", error);
    yield put(deleteImageResponse({data : error.message, success: false}));
  }
}

function* createLocationSaga(action) {
  try {
    const isUpdateDeviceProfile = action.payload;
    const { formFields, deviceProfileFormField } = yield select((state) => ({
      formFields: state?.location?.ui?.form?.fields,
      deviceProfileFormField: state?.deviceProfile?.ui?.form?.fields,
    }));
    yield call(createLocationAPI, formFields);

    if (isUpdateDeviceProfile) {
      yield put(
        updateUI({
          key: "form",
          value: {
            isOpen: true,
            fields: {
              ...deviceProfileFormField,
              step3: {
                ...deviceProfileFormField.step3,
                locations: deviceProfileFormField.step3.locations.map(
                  (location, index) => {
                    if (
                      deviceProfileFormField?.step3?.currentLocationIndex ===
                      index
                    ) {
                      return {
                        ...deviceProfileFormField.step3.locations[index],
                        currentLocation: "new",
                        new: {
                          ...deviceProfileFormField.step3.locations[index]?.new,
                          pointName: {
                            isValid: false,
                            class: "",
                            value: formFields?.pointName,
                            error: "",
                          },
                          address: {
                            isValid: false,
                            class: "",
                            value: formFields?.address,
                            error: "",
                            mapBoxTheme: {
                              cssText: `
                              .Input {
                                  height: 43px;
                                  font-size: 1rem;
                                  font-weight: 400;
                                  color: #000;
                                  font-family: system-ui;
                                  pointer-events: none;
                              }
                              .ClearBtn {
                                  display: none !important;
                              }
                          `,
                              variables: {
                                unit: "14px",
                                padding: "0.5em",
                                border: "1px solid",
                                borderRadius: "4px",
                                boxShadow: "none",
                              },
                            },
                          },
                          latitude: {
                            isValid: false,
                            class: "",
                            value: formFields?.latitude,
                            error: "",
                          },
                          trigger: {
                            isValid: false,
                            class: "",
                            value:
                              deviceProfileFormField?.step3?.locations[index]
                                ?.trigger?.value || "entry and exit",
                            error: "",
                          },
                          longitude: {
                            isValid: false,
                            class: "",
                            value: formFields?.longitude,
                            error: "",
                          },
                          radius: {
                            isValid: true,
                            class: "",
                            value: formFields?.radius,
                            error: "",
                          },
                          alerttype: {
                            isValid: false,
                            class: "",
                            value:
                              deviceProfileFormField?.step3?.locations[index]
                                ?.alerttype?.value || "notification",
                            error: "",
                          },
                        },
                      };
                    }

                    return location;
                  }
                ),
              },
            },
          },
        })
      );
      yield put(fetchRequest());
    }

    yield put(createSuccess("Location created successfully"));
  } catch (error) {
    console.log("error", error);
    yield put(createFailure(error.message));
  }
}

const createLocationAPI = async (query) => {
  try {
    const response = await fetch(createLocationEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        tags: [
          {
            kind: "ts.tag.site",
            name: query?.pointName,
            address: query?.address,
            lat_value: query?.latitude,
            long_value: query?.longitude,
            radius: query?.radius < 1 ? 500 : query?.radius,
          },
        ],
      }),
    });

    if (!response.ok) new Error("API error");

    const LocationList = await response.json();
    if (LocationList.length === 0) {
      return LocationList;
    }
    return LocationList;
  } catch (error) {
    console.log(error);
  }
};

function* downloadSaga() {
  try {
    const response = yield call(apiDownload);      
    const filterKind = response?.locations?.filter(
      (item) => {
        const kind = item?.tags ? item?.tags?.[0]?.kind : item?.kind ;
        return kind === "ts.tag.site"
      }
    );
    JSONToCSVDownload(CSVFormat(filterKind), "location_download.csv");

    yield put(downloadSuccess([...filterKind]));
  } catch (error) {
    console.log("error", error);
    yield put(downloadFailure(error.message));
  }
}

const CSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => {
    let record = json;
    if(json.tags && json.tags.length > 0){
      record = {...json, ...json.tags[0]};
    }
    return {
    id: json.id,
    createdon: record?.createdon,
    lastUpdated: record?.lastupdated,
    billingaccountid: record?.billingaccountid,
    name: record?.name,
    address: record?.address,
    loc_type:record?.loc_type,
    lat_value: record?.lat_value,
    long_value: record?.long_value,
    radius: record?.radius,
  }});
};

async function apiDownload() {
  return fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    }),
  }).then((response) => response.json());
}

export function* FetchLocationSaga() {
  yield takeLatest(locationTypes.FETCH_REQUEST, fetchLocationSaga);
}

export function* FetchLocationSagaAll() {
  yield takeLatest(locationTypes.FETCH_REQUEST_ALL, fetchLocationSagaAll);
}

export function* LocationDownloadSaga() {
  yield takeLatest(locationTypes.DOWNLOAD_REQUEST, downloadSaga);
}

export function* CreateLocationSaga() {
  yield takeLatest(locationTypes.CREATE_REQUEST, createLocationSaga);
}

export function* UploadImageSaga() {
  yield takeLatest(locationTypes.UPLOAD_IMAGE_REQUEST, uploadImageSaga);
}

export function* DeleteImageSaga() {
  yield takeLatest(locationTypes.DELETE_IMAGE_REQUEST, deleteImageSaga);
}

export function* FetchImageSaga() {
  yield takeLatest(locationTypes.FETCH_IMAGE_REQUEST, fetchImageSaga);
}
